var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"carouselItem"}},[(_vm.active)?_c('div',{staticClass:"cz-carousel-item",class:{reserve: _vm.reserve}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }